import * as React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';

import loadable from '@common/react/loadable/loadableSettings';
import NotFoundRoute from '@common/react/components/Routes/NotFoundRoute';

import Layout from '@app/components/Layout';
import { MainRoute } from '@app/components/Routes/MainRoute';

const Home = loadable(() =>
	import(/* webpackChunkName: "HomePage" */ '@app/components/Pages/Home/Home'));
const Blog = loadable(() =>
	import(/* webpackChunkName: "BlogPage" */ '@app/components/Pages/Blog/Blog'));
const Article = loadable(() =>
	import(/* webpackChunkName: "ArticlePage" */ '@app/components/Pages/Article/Article'));
const Section = loadable(() =>
	import(/* webpackChunkName: "SectionPage" */ '@app/components/Pages/Section/Section'));
const About = loadable(() =>
	import(/* webpackChunkName: "SectionPage" */ '@app/components/Pages/About/About'));
const BeforeAfter = loadable(() =>
	import(/* webpackChunkName: "BeforeAfterPage" */ '@app/components/Pages/BeforeAfterList/BeforeAfterList'));

export const baseRoutes = (<>
	<Route path="/" element={<MainRoute />}>
		<Route path="/" element={<Home />} />
		<Route path="/about" element={<About />} />
		<Route path="/gallery" element={<BeforeAfter />} />
		<Route path="/blog" element={<Blog />} />
		<Route path="/blog/:path" element={<Article />} />
		<Route path="/:path/*" element={<Section />} />
	</Route>
	<Route path="*" element={<NotFoundRoute openRoute={MainRoute} />} />
</>);

export const clientRoutes = (<Route
	element={<Layout>
		<Outlet />
	</Layout>}
>
	{baseRoutes}
</Route>);

export const routes = (<Layout>
	<Routes>
		{baseRoutes}
	</Routes>
</Layout>);
